import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const FilmIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1129 1024",
    fill: "currentColor",
    width: size || '1129',
    height: size || '1024'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1052.672 282.624h-117.76v-104.448h117.76v104.448zM1052.672 479.232h-117.76v-104.448h117.76v104.448zM1052.672 673.792h-117.76v-104.448h117.76v104.448zM1052.672 850.944h-117.76v-105.472h117.76v105.472zM295.936 282.624h564.224v462.848h-564.224v-462.848zM221.184 282.624h-117.76v-104.448h117.76v104.448zM221.184 479.232h-117.76v-104.448h117.76v104.448zM221.184 673.792h-117.76v-104.448h117.76v104.448zM221.184 850.944h-117.76v-105.472h117.76v105.472zM1052.672 8.192v104.448h-117.76v-104.448h-74.752v153.6h-564.224v-153.6h-74.752v104.448h-117.76v-104.448h-74.752v1005.568h74.752v-105.472h117.76v105.472h74.752v-152.576h564.224v152.576h74.752v-105.472h117.76v105.472h74.752v-1005.568h-74.752z",
    fillRule: "evenodd"
  }));
};
FilmIcon.displayName = 'FilmIcon';
export default FilmIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FilmIcon.js.map